import i18n from '@plugins/i18n';

import BaseValidator from './BaseValidator';

export class IsFalseValidator extends BaseValidator {
    static key = 'isFalse';

    static validator(value, label) {
        if (!value !== false) {
            return i18n.t('validator.false', { field: label });
        }

        return true;
    }

    static arguments() {
        return [];
    }
}

export default IsFalseValidator;
